import {
	FRIEND_REQUEST_BEGIN,
	FRIEND_REQUEST_FAIL,
	FRIEND_REQUEST_SUCCESS, IGNORE_BEGIN, IGNORE_FAIL, IGNORE_SUCCESS, logout,
	UNIGNORE_BEGIN, UNIGNORE_FAIL,
	UNIGNORE_SUCCESS,
	UPDATED_MY_USER
} from '../actions/user';

const initialState = {
	friendRequestPending: false,
	ignoreRequestPending: false,
	activeFriendServerRequests: {},
	myPlayer: {},
};

export default (state = initialState, action) => {
	switch(action.type) {
		case UPDATED_MY_USER: {
			return {
				...state,
				myPlayer: { ...myUser, id: myUser.id }
			};
		}
		case FRIEND_REQUEST_BEGIN: {

			const pending = { ...state.activeFriendServerRequests };
			pending[action.payload.player.id] = true;

			return {
				...state,
				friendRequestPending: true,
				activeFriendServerRequests: pending,
			};
		}
		case FRIEND_REQUEST_SUCCESS: {
			const pending = { ...state.activeFriendServerRequests };
			delete pending[action.payload.player.id];
			return {
				...state,
				friendRequestPending: false,
				activeFriendServerRequests: pending,
			};
		}
		case FRIEND_REQUEST_FAIL: {
			const pending = { ...state.activeFriendServerRequests };
			delete pending[action.payload.player.id];
			return {
				...state,
				friendRequestPending: false,
				activeFriendServerRequests: pending,
			};
		}
		case IGNORE_BEGIN:
			myUser.ignore_list[action.payload.id] = action.payload;
			return {
				...state,
				ignoreRequestPending: true,
			};
		case UNIGNORE_BEGIN:
			delete myUser.ignore_list[action.payload.id];
			return {
				...state,
				ignoreRequestPending: true,
			};
		case IGNORE_SUCCESS:
			myUser.ignore_list[action.payload.id] = action.payload;
			return {
				...state,
				ignoreRequestPending: false,
			};
		case UNIGNORE_SUCCESS:
			delete myUser.ignore_list[action.payload.id];
			return {
				...state,
				ignoreRequestPending: false,
			};
		case IGNORE_FAIL:
			delete myUser.ignore_list[action.payload.id];
			return {
				...state,
				ignoreRequestPending: false,
			};
		case UNIGNORE_FAIL:
			myUser.ignore_list[action.payload.id] = action.payload;
			return {
				...state,
				ignoreRequestPending: false,
			};
		default:
			return state;
	}
}